import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ReactCookieConsent, { getCookieConsentValue } from 'react-cookie-consent';

const CookieConsent = () => {
  const [cookieConsent, setCookieConsent] = useState(() => getCookieConsentValue());
  const handleCookieConsent = (value) => {
    setCookieConsent(value);
  };

  if (cookieConsent === undefined) {
    return (
      <section>

            <ReactCookieConsent
              buttonClasses='btn btn-primary m-2'
              declineButtonClasses='btn btn-outline-primary m-2'
              containerClasses='bg-dark position-relative'
              disableButtonStyles={true}
              location='top'
              buttonText='Akzeptieren'
              declineButtonText='Ablehnen'
              ariaDeclineLabel='Cookie ablehnen'
              ariaAcceptLabel='Cookie akzeptieren'
              enableDeclineButton
              onAccept={() => handleCookieConsent(true)}
              onDecline={() => handleCookieConsent(false)}
            >
              Diese Website verwendet Cookies um Ihr Erlebnis auf dieser Website zu verbessern.
            </ReactCookieConsent>
      </section>
    );
  }

  return null;
};

export default CookieConsent;
